import { Grid, Stack } from "@mui/material";
import { CaseInfoItem } from "@/features/case/components/CaseBasicInfo/CaseInfoItem";
import { Button } from "@/components/elements/Button";
import { TGetJobDto } from "@/api/services/main/job/dtos/get-job.dto";
import { FCC } from "@/types/common";
import { Link } from "react-router-dom";
import { AppRoutes } from "@/routes/config";
import { findLabelByValue, findLabelsByValue } from "@/utils/object";
import { useEnum } from "@/api/services/global/enum";
import { useMemo } from "react";
import { NATIONALITY_ANY_VALUE, NATIONALITY_ANY_LABEL } from "@/constants/nationality";

type TCaseRequestInfoProps = {
  jobInfo: TGetJobDto;
  isSharedView?: boolean;
};

export const CaseRequestInfo: FCC<TCaseRequestInfoProps> = ({ jobInfo, isSharedView = false }) => {
  const { id, genders, skillsExperience, japaneseLevelType, japaneseLevelOther, nationalities, nationalityIds } = jobInfo;
  const urlJobDetail = AppRoutes.jobDetail.replaceAll(":jobId", String(id));
  const { data: genderOptions } = useEnum("EGender");
  const { data: japaneseLevelTypeOptions } = useEnum("EJapaneseLevelType");

  const nationalitiesList = useMemo(() => {
    const hasAnyNationality = nationalityIds?.some((id) => String(id) === String(NATIONALITY_ANY_VALUE));

    if (hasAnyNationality) {
      return NATIONALITY_ANY_LABEL;
    }

    return nationalities?.map((nationality) => nationality.nationalityName).join("、");
  }, [nationalityIds, nationalities]);

  return (
    <Grid container spacing={2} p={2}>
      <Grid item xs={6}>
        <CaseInfoItem label="国籍" value={nationalitiesList} />
      </Grid>
      <Grid item xs={6}>
        <CaseInfoItem label="性別" value={findLabelsByValue(genderOptions, genders ?? [])} />
      </Grid>
      <Grid item xs={6}>
        <CaseInfoItem label="必要な技能・経験" value={skillsExperience} />
      </Grid>
      <Grid item xs={6}>
        <CaseInfoItem label="必要な日本語レベル" value={findLabelByValue(japaneseLevelTypeOptions, japaneseLevelType)} />
      </Grid>
      <Grid item xs={12}>
        <CaseInfoItem label="必要な日本語レベル（その他）" value={japaneseLevelOther} />
      </Grid>
      {!isSharedView && (
        <Grid item xs={12}>
          <Stack direction="row" spacing={2} justifyContent={"end"}>
            <Button
              size="sm"
              component={Link}
              // Open job detail in a new tab and deep-link to the section via URL hash.
              // JobDetail maps "#requirement" → the「応募要件」section and auto-scrolls there on load.
              to={`${urlJobDetail}#requirement`}
              variant="ghost"
              target="_blank"
              sx={{ width: "102px" }}
              // Prevent the button from taking focus on click (it opens a new tab, so focus would
              // otherwise linger here and keep the focus/active style). Keyboard focus still works.
              onMouseDown={(e) => e.preventDefault()}
            >
              詳細を見る
            </Button>
          </Stack>
        </Grid>
      )}
    </Grid>
  );
};
